import Cookies from 'universal-cookie';

/**
 * Get a cookie by name.
 *
 * @param {string} name
 * @returns {?string}
 */
export function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        return parts.pop().split(';').shift();
    }
    return null;
}

/**
 * Set a cookie.
 */
export function setCookie({ name, value, expires, path = '/' }) {
    const parts = [value];

    if (expires) {
        const date = new Date(Date.now() + (expires * 1000));
        parts.push(`expires=${date.toUTCString()}`);
    }

    document.cookie = `${name}=${parts.join(';')};path=${path}`;
}

/**
 * Erase a existing cookie
 */
export function eraseCookie(name) {
    if (getCookie(name)) document.cookie = `${name}=;expires=1990-01-01;path=/`;
}

/**
 * @type {Cookies}
 * @return universal-cookie instance for easier cookie handling (see https://www.npmjs.com/package/universal-cookie)
 */
export const cookies = new Cookies();

/**
 * Get the cookie domain with awareness of current environment - localhost for dev,
 * .staging.karriere.at for staging and .karriere.at
 * @returns {string}
 */
export function getCookieDomain() {
    const env = import.meta.env.VITE_APP_ENV ?? 'production';
    switch (import.meta.env.VITE_APP_ENV ?? 'production') {
    case 'production': return '.karriere.at';
    case 'staging': return '.staging.karriere.at';
    case 'local': return 'localhost';
    default: throw new Error(`Unexpected environment value ${env}`);
    }
}
